export default __webpack_public_path__ + "media/img/mappin-36b1b6625bfd0ab69bb6f1df75d46bc0.svg";